import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AccountSelection from '../apps/AccountSelection/components';
import { ROLE, useIsProvider } from '../components/common';
import { useAuth, useBodyClass, useRole } from '../hooks';

function AccountSelectionPage() {
    const auth = useAuth();
    const role = useRole();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [bodyClasses, setBodyClasses] = useState<string[]>([]);

    const isProvider = useIsProvider();

    useEffect(() => { document.title = t('My accounts'); }, [t]);

    useEffect(() => {
        const tmp: string[] = [];
        if (auth.account) {
            if (isProvider || role.label === ROLE.SITE_ADMIN) {
                tmp.push('page-producer');
            } else {
                tmp.push('page-subscriber');
            }
            const next = params.get('next');
            if (next) {
                navigate(next, { replace: true });
            }
        } else {
            if (!(window.location.pathname.startsWith('/select-accounts') || window.location.pathname === '/')) {
                navigate(`/select-accounts?next=${encodeURIComponent(window.location.pathname + window.location.search)}`);
            }
            tmp.push('page-subscriber');
        }
        setBodyClasses(tmp);
    }, [auth.account, auth.user, role.label, params]);

    useBodyClass(bodyClasses);

    return (
        <AccountSelection />
    );
}

export default AccountSelectionPage;
